import { useCallback, useEffect, useState } from "react";
import { Eraser, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("nl-NL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const TONE = { clean_start: "bg-destructive text-white", cleanup_before: "bg-secondary text-secondary-foreground", bulk_delete: "bg-foreground text-background", delete_user: "bg-muted text-foreground" };

// Logboek van opschoningen (Schone start, Opschonen tot datum, handmatige verwijderingen) — onder Geplande taken.
export default function CleanupLog({ refreshKey }) {
  const [entries, setEntries] = useState(null);
  const load = useCallback(async () => {
    try { setEntries((await api.get("/admin/cleanup-log", { params: { limit: 50 } })).data.entries); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <div className="border-t-2 border-foreground" data-testid="cleanup-log">
      <div className="px-5 pt-4 pb-2 flex items-center justify-between gap-2 flex-wrap">
        <p className="font-display uppercase font-bold text-xs tracking-widest inline-flex items-center gap-1.5"><Eraser className="w-3.5 h-3.5" /> Opschoonlogboek</p>
        <span className="text-[11px] text-muted-foreground">Schone start, Opschonen tot datum en handmatig verwijderde accounts · laatste 50</span>
      </div>
      {entries === null ? <div className="px-5 pb-4 text-sm text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Laden…</div>
        : entries.length === 0 ? <div className="px-5 pb-4 text-sm text-muted-foreground" data-testid="cleanup-log-empty">Nog geen opschoningen uitgevoerd.</div> : (
        <table className="w-full text-sm" data-testid="cleanup-log-table">
          <thead><tr className="bg-foreground text-background">{["Wanneer", "Soort", "Door", "Wat"].map((h) => <th key={h} className="px-3 py-2 font-display uppercase text-[10px] tracking-widest text-left">{h}</th>)}</tr></thead>
          <tbody>
            {entries.map((e, i) => (
              <tr key={`${e.at}-${i}`} className="border-t border-border align-top" data-testid={`cleanup-log-row-${i}`}>
                <td className="px-3 py-2 font-mono-num text-xs whitespace-nowrap">{fmt(e.at)}</td>
                <td className="px-3 py-2 whitespace-nowrap"><span className={`px-1.5 py-0.5 text-[10px] font-display uppercase tracking-widest ${TONE[e.kind] || TONE.delete_user}`}>{e.label}</span></td>
                <td className="px-3 py-2 text-xs">{e.by}</td>
                <td className="px-3 py-2 text-xs">{e.summary}{e.details?.emails?.length ? <div className="text-muted-foreground truncate max-w-[520px]" title={e.details.emails.join(", ")}>{e.details.emails.join(", ")}</div> : null}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
